import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import { useIntl } from 'react-intl'
import TextButton from 'LuxKit/Button/TextButton'
import { CAREERS_PAGE_ANCHORS } from 'components/Pages/CareersPage/CareersPage'
import { pushWithRegion } from 'actions/NavigationActions'
import { useAppDispatch } from 'hooks/reduxHooks'
import Group from 'components/utils/Group'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'

const WorkWithUsPane = styled(Pane)`
  padding: ${rem(48)} 0;
`
const BodyTextNoMarginDesktop = styled(BodyText)`
  margin-top: ${rem(24)};
  ${mediaQueryUp.tablet} {
    margin-top: unset;
  }
`

function WorkWithUs() {
  const intl = useIntl()
  const dispatch = useAppDispatch()

  const heading = intl.formatMessage({
    id: 'a8FTsUctxl6rE2xANiAo',
    defaultMessage: 'Want to work with us?',
    description: 'About us page - work with us section heading on the about us page',
  })

  const passionateText = intl.formatMessage({
    id: 'T_RAJX6G_OYfIjlICsgs',
    defaultMessage: 'Are you passionate about travel and dedicated to delivering unparalleled experiences?',
    description: 'About us page - work with us first body paragraph on the about us page',
  })

  const joinUsText = intl.formatMessage({
    id: 'TpkUaLedwauBRM7OdPJd',
    defaultMessage: 'Come and join Luxury Escapes, recognised as one of the ‘Best Places to Work 2022’ by the Australian Financial Review.',
    description: 'About us page - work with us second body paragraph with award mention',
  })

  const viewPositionsLabel = intl.formatMessage({
    id: '5FUUxDme02cgi_Av9hS3',
    defaultMessage: 'View open positions',
    description: 'About us page - button to view career openings on the about us page',
  })

  return (
    <WorkWithUsPane>
      <LayoutContainer>
        <Group gap={24} direction="vertical" horizontalAlign="start">
          <Heading variant="heading2">
            {heading}
          </Heading>
          <div>
            <BodyText variant="large">
              {passionateText}
            </BodyText>
            <BodyTextNoMarginDesktop variant="large">
              {joinUsText}
            </BodyTextNoMarginDesktop>
          </div>
          <TextButton kind="primary" size="large" onClick={() => { dispatch(pushWithRegion('/careers#' + CAREERS_PAGE_ANCHORS.OPEN_POSITIONS)) }}>
            {viewPositionsLabel}
          </TextButton>
        </Group>
      </LayoutContainer>
    </WorkWithUsPane>
  )
}

export default WorkWithUs
